import { useContext } from "react";
import { DocumentGeneratorContext } from "./context";

export const useDocumentGeneratorNode = () => {
  const context = useContext(DocumentGeneratorContext);
  if (!context) {
    throw new Error(
      "useDocumentGeneratorNode must be used within a DocumentGeneratorProvider",
    );
  }
  return context;
};
